<ng-container>
  <property-tabs
    selectedStepId="selectedStepId"
  (beforeStepChange)="beforeStepChange($event.cb, $event.arg, $event.isBack)"></property-tabs>
  <router-outlet (activate)="onActivate($event)"></router-outlet>
  @if (isStepInfoReady) {
    <tg-rack>
      <tg-rack-item class="property-page-footer__container--large-margin">
        <tg-rack-item-primary>
          <property-page-footer
            (continue)="onContinue($event)"
            (createListing)="onCreateListing($event)"
            (saveAndCompleteLater)="onSaveAndCompleteLater()"
            (topUpCompleted)="onTopUpCompleted()"
            (editListing)="onEditListing()"
            (relistListing)="onRelistListing()">
          </property-page-footer>
        </tg-rack-item-primary>
      </tg-rack-item>
    </tg-rack>
  }
</ng-container>
<div class="property-home-page__feedback-email-button-container l-container">
  <tm-feedback-email-button class="property-home-page__feedback-email-button"></tm-feedback-email-button>
</div>
